import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useState } from "react";
import { useDimensions } from '../Util';

function GoogleAuth({ setProaddictiveUser, setToken }) {
    const { w, h } = useDimensions();
    const [loading, setLoading] = useState(false);

    const CLIENT_ID = '785996104280-r06hhvho7q9l9pbk6s1vl3gpt0j9n17f.apps.googleusercontent.com';

    const WelcomeMsgStyleClass = {
        fontFamily: "'Courier New', Courier, monospace",
        fontSize: 3 * h,
        fontWeight: 'normal',
        color: '#00ADB5',
        margin: 2 * h
    };

    const loginSuccess = async (credentialResponse) => {
        setLoading(true);
        const token = credentialResponse.credential;
        const bearerToken = "Bearer " + token;
        setToken(bearerToken);
        let googleUser = null;
        try {
            const verifyGoogleTokenResponse = await axios.post(
                "https://wpbzijab2a.execute-api.us-east-1.amazonaws.com/dev/verifyGoogleToken", 
                { token }
            );
            googleUser = verifyGoogleTokenResponse.data.user;
        } catch (error) {
            console.error("Error Verifying Token:", error);
        }
        try {
            const response = await axios.post(
                "https://wpbzijab2a.execute-api.us-east-1.amazonaws.com/dev/existingPaUser",
                { user: googleUser },
                {
                    headers: {
                        Authorization: bearerToken
                    }
                }
            );
            setProaddictiveUser(response.data);
        } catch (error) {
            console.error("Error fetching user data:", error);
            if (error.response?.data?.error === "User not found") {
                try {
                    const responseFromCreateUser = await axios.post(
                        "https://wpbzijab2a.execute-api.us-east-1.amazonaws.com/dev/createPaUser",
                        { user: googleUser },
                        {
                            headers: {
                                Authorization: bearerToken
                            }
                        }
                    );
                    if(responseFromCreateUser.data.message === "User created successfully"){
                        setProaddictiveUser(responseFromCreateUser.data.user);
                    }
                } catch (createError) {
                    console.error("Error creating user:", createError);
                }
            }
        }
        setLoading(false);
    };

    const handleLoginError = () => {
        setProaddictiveUser(null);
        setToken(null);
        alert("Your Login Failed");
    };

    // Custom Google Login Button
    const handleGoogleLogin = (renderProps) => (
        <button 
            onClick={renderProps.onClick} 
            disabled={renderProps.disabled}
            style={{
                padding: "10px 20px",
                fontSize: "16px",
                backgroundColor: "#00ADB5",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: renderProps.disabled ? "not-allowed" : "pointer",
                opacity: renderProps.disabled ? 0.6 : 1
            }}
        >
            Login with Google
        </button>
    );

    return (
        <div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <p style={WelcomeMsgStyleClass}>The longer you wait to quit, The harder it gets.</p>
            </div>

            {loading ? (
                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: 2 * h }}>
                    <div className="spinner" />
                    <style jsx="true">
                        {`
                            .spinner {
                                border: 4px solid #EEEEEE;
                                border-top: 4px solid #00ADB5;
                                border-radius: 50%;
                                width: 50px;
                                height: 50px;
                                animation: spin 2s linear infinite;
                            }
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                </div>
            ) : (
                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <GoogleOAuthProvider clientId={CLIENT_ID}>
                        <GoogleLogin 
                            onSuccess={loginSuccess} 
                            onError={handleLoginError} 
                            ux_mode="popup" // Ensure popup mode for Safari
                            render={handleGoogleLogin} // 👈 Custom login button
                        />
                    </GoogleOAuthProvider>
                </div>
            )}
        </div>
    );
}

export default GoogleAuth;
